const STORAGE_KEY = "lpxyz-view";
const buttons = document.querySelectorAll("[data-view-toggle]");

function updatePressedState(view) {
  buttons.forEach((button) => {
    button.setAttribute(
      "aria-pressed",
      String(button.dataset.viewToggle === view),
    );
  });
}

const projectsList = document.querySelector(".link-list--projects");
const originalProjectOrder = projectsList
  ? Array.from(projectsList.children)
  : [];

function sortProjectsByView(view) {
  if (!projectsList) return;

  if (view === "grid") {
    Array.from(projectsList.children)
      .sort((a, b) => Number(b.dataset.published) - Number(a.dataset.published))
      .forEach((item) => projectsList.appendChild(item));
  } else {
    originalProjectOrder.forEach((item) => projectsList.appendChild(item));
  }
}

function setView(view) {
  document.body.setAttribute("data-view", view);
  updatePressedState(view);
  sortProjectsByView(view);

  try {
    window.localStorage.setItem(STORAGE_KEY, view);
  } catch (e) {
    // localStorage unavailable (private browsing, disabled, etc.) — the
    // toggle still works for the current page load, it just won't persist.
  }
}

buttons.forEach((button) => {
  button.addEventListener("click", () => setView(button.dataset.viewToggle));
});

// The inline script in base.php already set data-view before paint, this
// just syncs the buttons' aria-pressed state and project order to match it.
const initialView =
  document.body.getAttribute("data-view") === "grid" ? "grid" : "list";
updatePressedState(initialView);
sortProjectsByView(initialView);

// Categories grid (front page): tilt each item between -10deg and 10deg.
document.querySelectorAll(".link-list--categories .link-list__item").forEach((item) => {
  const rotation = (Math.random() * 20 - 10).toFixed(2);
  item.style.setProperty("--rotate", `${rotation}deg`);
});

// Projects grid: tilt each item between -15deg and 15deg.
document.querySelectorAll(".link-list--projects .link-list__item").forEach((item) => {
  const rotation = (Math.random() * 30 - 15).toFixed(2);
  item.style.setProperty("--rotate", `${rotation}deg`);
});
